import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import css from './basicMoadal.module.scss'
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  display:'flex',
  flexDirection:'column'


};

export default function BasicModal({open,onChange,children}) {
  
  
  const handleClose = () => onChange(false);

  return (
    
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={css.modal_wrap}>
        <div className={css.content}>
          {children}
        </div>
        <div className={css.footer}>

        </div>
        </div>
      </Modal>
    
  );
}
